/** @jsxImportSource @emotion/react */
import React, { useEffect, useState } from "react";
import type { LatLngTuple } from "leaflet";


import * as T from "@goodgym/graphql/types";

export type TaskRequestMapProps = {
  taskRequest: T.TaskRequestFragment | T.CoachReferralFragment;
};

const TaskRequestMap: React.FC<TaskRequestMapProps> = ({ taskRequest }) => {
  const [MapComponents, setMapComponents] = useState<any>(null);

  useEffect(() => {
    // Only runs on client
    import("react-leaflet").then((mod) => {
      setMapComponents({
        MapContainer: mod.MapContainer,
        TileLayer: mod.TileLayer,
        Circle: mod.Circle,
      });
    });
  }, []);
  useEffect(() => {
      // @ts-ignore: dynamic import of CSS is fine, TS doesn't need to understand it
    import('leaflet/dist/leaflet.css');
  }, []);

  if (
    typeof taskRequest.lat !== "number" ||
    typeof taskRequest.lng !== "number" ||
    typeof window === "undefined" ||
    !MapComponents
  ) return null;

  const { MapContainer, TileLayer, Circle } = MapComponents;
  const center: LatLngTuple = [taskRequest.lat, taskRequest.lng];

  return (
    <MapContainer
      center={center}
      zoom={15}
      scrollWheelZoom={false}
      style={{
        minHeight: "300px",
        maxHeight: "800px",
        width: "100%",
        zIndex: 1,
      }}
    >
      <TileLayer
        attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
      />
      <Circle
        center={center}
        radius={200}
        pathOptions={{
          color: "#E11018",
          fillColor: "#E11018",
          fillOpacity: 0.1,
          opacity: 0.5,
        }}
      />
    </MapContainer>
  );
};

export default TaskRequestMap;
